module.exports = __webpack_public_path__ + "static/media/varie6d.a8fa8845.jpg";